import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import Api from '@app/services/api';

interface IParams {
  stage_uid: string;
  name: string;
}

export const useUpdateStageQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ stage_uid, name }: IParams) => {
      await Api.orders.putStages(stage_uid, name);
    },
    onSuccess: async () => {
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
      await client.invalidateQueries(['getProcess']);
    },
    onError: async () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
      await client.invalidateQueries(['getProcess']);
    },
  });
};
